import { tenantApi } from '@/modules/tenant/services/tenantApi';
import type {
  AccountingSyncBatch,
  AccountingSyncSettings,
  AccountingSyncSummary,
  CreditNote,
  InvoiceUnlock,
  Payment,
  UpdateAccountingSyncSettingsRequest,
  WorkOrder,
} from '../types/service.types';

/** D15-08/D15-20: the finance sync surface. The CSV is a separate GET (`downloadUrl`). */
export const accountingSyncApi = {
  summary: () => tenantApi.getOne<AccountingSyncSummary>('/accounting-sync'),

  workOrders: (page: number, perPage: number) =>
    tenantApi.getPaginated<WorkOrder>(`/accounting-sync/work-orders?page=${page}&per_page=${perPage}`),

  payments: (page: number, perPage: number) =>
    tenantApi.getPaginated<Payment>(`/accounting-sync/payments?page=${page}&per_page=${perPage}`),

  creditNotes: (page: number, perPage: number) =>
    tenantApi.getPaginated<CreditNote>(`/accounting-sync/credit-notes?page=${page}&per_page=${perPage}`),

  batches: (page: number, perPage: number) =>
    tenantApi.getPaginated<AccountingSyncBatch>(`/accounting-sync/batches?page=${page}&per_page=${perPage}`),

  unlocks: (page: number, perPage: number) =>
    tenantApi.getPaginated<InvoiceUnlock>(`/accounting-sync/unlocks?page=${page}&per_page=${perPage}`),

  exportBatch: () => tenantApi.postOne<AccountingSyncBatch>('/accounting-sync/batches'),

  settings: () => tenantApi.getOne<AccountingSyncSettings>('/accounting-sync/settings'),

  updateSettings: (body: UpdateAccountingSyncSettingsRequest) =>
    tenantApi.putOne<AccountingSyncSettings>('/accounting-sync/settings', body),

  /** Literal /api URL for window.open (cookie-authenticated same-origin GET), like `invoicePdfUrl`. */
  downloadUrl: (id: string) => `/api/accounting-sync/batches/${id}/download`,
};
